import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StripeLoaderService {
  private stripePromise: Promise<any> | null = null;

  loadStripe(): Promise<any> {
    if (!this.stripePromise) {
      this.stripePromise = new Promise((resolve, reject) => {
        if ((window as any).Stripe) { resolve((window as any).Stripe); return; }
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';
        script.onload = () => resolve((window as any).Stripe);
        script.onerror = () => {
          this.stripePromise = null;
          reject(new Error('Failed to load Stripe.js'));
        };
        document.head.appendChild(script);
      });
    }
    return this.stripePromise;
  }
}
